"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Eyebrow = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
exports.Eyebrow = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.el, EyebrowElement = _c === void 0 ? 'span' : _c, inline = _a.inline, italic = _a.italic, bold = _a.bold, _d = _a.size, size = _d === void 0 ? 'medium' : _d, props = __rest(_a, ["children", "className", "el", "inline", "italic", "bold", "size"]);
    var TextClasses = classnames_1.default('Eyebrow', className, (_b = {},
        _b["Eyebrow--" + size] = size,
        _b['d-i'] = inline,
        _b['d-b'] = !inline,
        _b['fw-bold'] = bold,
        _b['fs-italic'] = italic,
        _b['fs-normal'] = !italic && italic != null,
        _b));
    return (react_1.default.createElement(EyebrowElement, __assign({ ref: ref, className: TextClasses }, props), children));
});
//# sourceMappingURL=Eyebrow.js.map